var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
__export(exports, {
  default: () => Chain
});
var import_config = __toModule(require("./config"));
var import_util = __toModule(require("./util"));
class Chain {
  constructor(id) {
    this.name = null;
    this.description = null;
    this.nativeToken = null;
    this.tokenDecimals = null;
    this.isRelay = false;
    this.links = {};
    this.assets = {};
    this.rpcs = [];
    this.status = "INITIALIZED";
    this.id = id;
  }
  init() {
    return __async(this, null, function* () {
      this.status = "HYDRATING";
      const manifestPath = `${chaindirpath(this.id)}/manifest.json`;
      const manifest = yield (0, import_util.fetchRawFileContents)(manifestPath);
      Object.keys(manifest).forEach((key) => {
        this[key] = manifest[key];
      });
      this.links = manifest.links || {};
      this.assets = manifest.assets || {};
      this.rpcs = manifest.rpcs || [];
      this.status = "READY";
    });
  }
  get asset() {
    return new Proxy(this, {
      get: function(target, key) {
        const filename = target && target.assets[key];
        return filename ? `${import_config.sourcePath}${chaindirpath(target.id)}/assets/${filename}` : null;
      }
    });
  }
}
const chaindirpath = (id) => id.split("-").map((idPart, index) => index === 0 ? idPart : `parathreads/${idPart}`).join("/");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {});
